import { memo, useState } from "react";
import { Box, Grid, InputAdornment, TextField, Typography } from "@mui/material";

import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import usePtoBalancesColumns from "./hooks/usePtoBalancesColumns";
import { DataGridPremium } from "@mui/x-data-grid-premium";

const rawData = Array.from({ length: 50 }, (_, i) => {
  const id = i + 1;
  const names = ["John Doe", "Jane Smith", "Alice Johnson", "Bob Brown", "Carol White", "David Green", "Eve Black"];
  const randomName = names[Math.floor(Math.random() * names.length)];

  const getRandom = (max = 3) => Math.floor(Math.random() * (max + 1));

  return {
    id,
    UserName: `${randomName}`,
    Vacation: getRandom(),
    AdministrativeLeave: getRandom(),
    FuneralLeave: getRandom(),
    UnionBusiness: getRandom(),
    DepartmentBusiness: getRandom(),
    SickSelf: getRandom(),
    SickFamily: getRandom(),
    LeaveWithPay: getRandom(),
    LeaveWithoutPay: getRandom(),
    MilitaryLeave: getRandom(),
    LightDuty: getRandom(),
    FillIn: getRandom(),
    Injured: getRandom(),
    Reassigned: getRandom(),
    OpenPosition: getRandom(),
    EmergencyFill: getRandom(),
  };
});

const PtoBalances = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const clearSearch = () => {
    setSearchQuery("");
  };

  const columns = usePtoBalancesColumns();

  const filteredRows = rawData.filter((row) => row.UserName.toLowerCase().includes(searchQuery.toLowerCase()));

  const rows = filteredRows.map((item) => {
    const total = Object.values(item)
      .filter((val) => typeof val === "number")
      .reduce((acc, val) => acc + val, 0);
    return { ...item, Total: total };
  });

  const totalRow = filteredRows.reduce((acc, row) => {
    for (const key in row) {
      if (typeof row[key] === "number") {
        acc[key] = (acc[key] || 0) + row[key];
      }
    }
    acc.UserName = "Total";
    return acc;
  }, {});
  totalRow.Total = rows.reduce((sum, r) => sum + r.Total, 0);
  totalRow.id = "total";

  return (
    <>
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            PTO Balances
          </Typography>
        </Box>

        <Grid container spacing={2} className="my-2">
          <Grid item xs={12} md={4}>
            <TextField
              color={"secondary"}
              label="Search balances"
              placeholder="Search by balances name..."
              size="small"
              value={searchQuery}
              onChange={handleSearchChange}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchQuery.length > 0 ? (
                      <ClearIcon onClick={clearSearch} sx={{ cursor: "pointer" }} />
                    ) : (
                      <SearchIcon />
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: "calc(100vh - 300px)", width: "100%" }}>
              {rows?.length === 0 ? (
                <Typography className="mt-2" color="#6E7C87">
                  No balances found matching your search.
                </Typography>
              ) : (
                <DataGridPremium
                  rows={rows}
                  columns={columns}
                  getRowId={(row) => row.id}
                  hideFooter
                  disableRowSelectionOnClick
                  pinnedRows={{ bottom: [totalRow] }}
                  rowHeight={64}
                  sx={{
                    "& .MuiDataGrid-pinnedRows": {
                      backgroundColor: "#f5f5f5",
                      fontWeight: "bold",
                    },
                    "& .MuiTablePagination-selectLabel": {
                      margin: "0px",
                      color: "#0000008e",
                    },
                    "& .MuiTablePagination-displayedRows": {
                      margin: "0px",
                    },
                    "& .MuiTablePagination-actions": {
                      color: "#0000008e",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      color: "#565453",
                    },
                    "& .MuiDataGrid-cell:focus": {
                      outline: "none",
                    },
                    "& .MuiDataGrid-cell:focus-within": {
                      outline: "none",
                    },
                  }}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default memo(PtoBalances);
